module.exports = __webpack_public_path__ + "img/goods6-6.dee14090.jpg";